import React, { Component } from 'react'
import scrollIntoView from 'scroll-into-view-if-needed'
import ReactDOM from 'react-dom'
import Item from './Item'


export default class Playlist extends Component {

  scrollElementIntoViewIfNeeded = (domNode) => {



      let containerDomNode = ReactDOM.findDOMNode(domNode);
        scrollIntoView(containerDomNode, {
          scrollMode: 'if-needed',
          block: 'nearest',
          inline: 'nearest',
        })

  }

  render() {
    return (
      <div id="playlist" className="playlist">
      <div className="header">
      <span className="title">
        Playlist
      </span>
      </div>
      {this.props.list.map((item, i) => {
        return (
          <Item
            curr={this.props.index === i}
            item={item}
            key={i}
            onClick={() => this.props.onClickItem(i)}
            scrollIntoView={this.scrollElementIntoViewIfNeeded}
          />
        )
      })}

    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Playlist.js